import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import AdminApiClient from '../../../utils/http-clients/AdminApiClient'
import { IEmployeeResponse, IEmployeeState } from '../../types'

const adminApiClient = AdminApiClient.getInstance()

export const fetchShowEmployee = createAsyncThunk(
  'listEmployees/fetchShowEmployee',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await adminApiClient.employee(id)
      return response.data
    } catch (error: any) {
      if (!error.response) {
        throw error
      }

      return rejectWithValue(error)
    }
  }
)

const initialState: IEmployeeState = {
  isLoading: false,
  response: null,
  error: null
}

const showEmployeeSlice = createSlice({
  name: 'employees/show',
  initialState,
  reducers: {
    resetShowEmployee: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchShowEmployee.pending, state => {
      state.isLoading = true
      state.response = null
      state.error = null
    })

    builder.addCase(fetchShowEmployee.fulfilled, (state, action: PayloadAction<IEmployeeResponse>) => {
      state.isLoading = false
      state.response = action.payload
      state.error = null
    })

    builder.addCase(fetchShowEmployee.rejected, (state, action) => {
      state.isLoading = false
      state.response = null
      state.error = action.payload
    })
  }
})

export default showEmployeeSlice.reducer
export const { resetShowEmployee } = showEmployeeSlice.actions
